export default{
	  bind: function (el, binding, vnode) {
			el.ondragover=function(event){
				event.preventDefault();
			}
			el.ondrop=function (event){
				event.preventDefault();
				var id=event.dataTransfer.getData("id");
				if(id!='undefined' && id!=''){
					var x1=event.dataTransfer.getData("x");
					var y1=event.dataTransfer.getData("y");
					var x2=event.pageX;
					var y2=event.pageY;
					var dx=x2-x1;
					var dy=y2-y1;
					
					var obj=document.getElementById(id)
					var left=obj.offsetLeft+dx
					var top1=obj.offsetTop+dy
					obj.style.left=left+'px';
					obj.style.top=top1+'px';
				}	
			}
		}
	}


// WEBPACK FOOTER //
// ./src/vue/directive/v-mymovedestination.js